import React from "react";

const Pagination = ({ page, setPage, totalPages, totalEntries, entriesPerPage = 10 }) => {
  const handlePrev = () => setPage(Math.max(page - 1, 1));
  const handleNext = () => setPage(Math.min(page + 1, totalPages));

  const startEntry = (page - 1) * entriesPerPage + 1;
  const endEntry = Math.min(page * entriesPerPage, totalEntries);

  // Determine page numbers around current page
  const pageNumbers = [];
  if (page > 1) pageNumbers.push(page - 1);
  pageNumbers.push(page);
  if (page < totalPages) pageNumbers.push(page + 1);
  const uniquePageNumbers = [...new Set(pageNumbers.filter(p => p >= 1 && p <= totalPages))];

  const PaginationButton = ({ children, onClick, active = false, disabled = false }) => (
    <li className={`page-item d-flex align-items-center ${disabled ? 'disabled' : ''}`}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={`btn btn-sm page-link p-0 w-32-px h-32-px d-flex align-items-center justify-content-center rounded-0 
                    ${active ? 'bg-primary-600 text-white border-primary-600' : 'text-muted border-light bg-white'}
                    ${disabled ? 'opacity-50' : ''}`}
      >
        {children}
      </button>
    </li>
  );

  return (
    <div className="d-flex justify-content-between align-items-center mt-20">
      <div className="text-muted">
        Showing {startEntry} to {endEntry} of {totalEntries} entries
      </div>

      <nav aria-label="Table pagination">
        <ul className="pagination d-flex align-items-center mb-0">
          <PaginationButton onClick={() => setPage(1)} disabled={page === 1}>&laquo;</PaginationButton>
          <PaginationButton onClick={handlePrev} disabled={page === 1}>&lsaquo;</PaginationButton>

          {uniquePageNumbers.map(p => (
            <PaginationButton key={p} onClick={() => setPage(p)} active={p === page}>
              {p}
            </PaginationButton>
          ))}

          <PaginationButton onClick={handleNext} disabled={page === totalPages}>&rsaquo;</PaginationButton>
          <PaginationButton onClick={() => setPage(totalPages)} disabled={page === totalPages}>&raquo;</PaginationButton>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
